module.exports = __webpack_public_path__ + "static/media/validatePhoneNumber_success.fe17f1ed.svg";